import { PanelSection } from "./PanelSection";
import { DefaultHashtags } from "./StudioDefaultsPanel";

const TITLE_MAX = 100;
const DESC_MAX = 5000;
const inputCls = "w-full bg-white border border-zinc-200 hover:border-zinc-300 rounded-[4px] px-3 py-2.5 text-sm text-zinc-900 outline-none focus:border-rose-500 transition-colors";

const CharCounter = ({ n, max, testId }) => (
  <div data-testid={testId}
    className={`text-right text-xs font-mono ${n >= max ? "text-red-600" : n >= max * 0.9 ? "text-amber-600" : "text-zinc-400"}`}>
    {n.toLocaleString()}/{max.toLocaleString()}
  </div>
);

// Title, description and hashtags sent to YouTube. Shown under the video and in the Publish popup (prefix keeps test ids unique).
export function PublishDetails({ pubTitle, setPubTitle, pubDesc, setPubDesc, prefix = "details", className = "mt-6", ...tagProps }) {
  return (
    <div className={`${className} flex flex-col gap-6`} data-testid={`${prefix}-publish-details`}>
      <PanelSection label="Video Title" testId={`${prefix}-title-section`}>
        <input value={pubTitle} onChange={(e) => setPubTitle(e.target.value)} maxLength={TITLE_MAX}
          data-testid={`${prefix}-title-input`} placeholder="Video title" className={inputCls} />
        <CharCounter n={pubTitle.length} max={TITLE_MAX} testId={`${prefix}-title-char-counter`} />
      </PanelSection>
      <PanelSection label="Video Description" testId={`${prefix}-desc-section`}>
        <textarea value={pubDesc} onChange={(e) => setPubDesc(e.target.value)} rows={5} maxLength={DESC_MAX}
          data-testid={`${prefix}-desc-input`} placeholder="Video description" className={`${inputCls} resize-y`} />
        <CharCounter n={pubDesc.length} max={DESC_MAX} testId={`${prefix}-desc-char-counter`} />
      </PanelSection>
      <DefaultHashtags prefix={prefix} {...tagProps} />
    </div>
  );
}
